import { create } from "zustand"
import { devtools } from "zustand/middleware"

// Daily 리포트 세션 모드에서 Custom Table 섹션이 "이 표에서만" 다시 고른 세션 목록의 임시(transient) 상태.
// Stats by Player 의 섹션 내 세션 선택을 Custom Table 로 옮긴 것(#99). reportSort / reportColumnFilter 와 같은 스코프 규칙 —
// 화면(CustomTableSection)이 쓰고 PDF(PrintableCustomTableSection)가 읽어 같은 세션 기준으로 집계한다.
// undefined 면 리포트 필터에서 고른 세션 전체를 쓴다. 템플릿이 실제로 바뀌면 폐기, 같은 템플릿 재진입에는 보존.
interface ReportSessionSelectionState {
  selections: Record<string, number[] | undefined>
  lastTemplateId: Record<string, string | number | undefined>
  setSelection: (sectionKey: string, sessionIds: number[] | undefined) => void
  syncTemplate: (reportType: string, templateId: string | number | undefined) => void
}

export const createReportSessionSelectionStore = create<ReportSessionSelectionState>()(
  devtools(
    (set) => ({
      selections: {},
      lastTemplateId: {},
      setSelection: (sectionKey, sessionIds) =>
        set((state) => ({ selections: { ...state.selections, [sectionKey]: sessionIds } })),
      syncTemplate: (reportType, templateId) =>
        set((state) => {
          if (state.lastTemplateId[reportType] === templateId) {
            return state
          }

          return {
            selections: Object.fromEntries(
              Object.entries(state.selections).filter(([key]) => !key.startsWith(`${reportType}:`)),
            ),
            lastTemplateId: { ...state.lastTemplateId, [reportType]: templateId },
          }
        }),
    }),
    {
      store: "reportSessionSelection",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)

/**
 * 섹션에서 고른 세션을 리포트 필터의 세션 범위 안으로 좁힌다.
 * 리포트 필터에서 세션을 빼면 섹션 선택에도 남아 있으면 안 되고, 하나도 안 남으면 리포트 세션 전체로 되돌린다.
 */
export function resolveSectionSessionIds(
  reportSessionIds: number[],
  sectionSelection: number[] | undefined,
): number[] {
  if (!sectionSelection) {
    return reportSessionIds
  }
  const narrowed = sectionSelection.filter((id) => reportSessionIds.includes(id))

  return narrowed.length ? narrowed : reportSessionIds
}
